export default __webpack_public_path__ + "components/bike-park-header/static/background--2-f73de566dfef584a44dbd0a89ff3f146.jpg";